import { useTranslation } from "react-i18next";
import { Control, Controller } from "react-hook-form";
import { FormControl, FormLabel, TextField, FormHelperText } from "@mui/material";

import { CreatePostFormData } from "../../api/types/feed.types";
import { commonStyles } from "../../pages/CreatePostPage/components/CreatePostForm/index";

interface DescriptionFieldProps {
  control: Control<CreatePostFormData>;
  name: "description";
  error?: string;
}

export const DescriptionField = ({ control, name, error }: DescriptionFieldProps) => {
  const { t } = useTranslation("feed", { keyPrefix: "postForm" });

  return (
    <FormControl fullWidth component="fieldset" sx={commonStyles.formControl} error={!!error}>
      <FormLabel sx={commonStyles.formLabel}>{t("description")}</FormLabel>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            fullWidth
            multiline
            rows={6}
            sx={commonStyles.textField}
            placeholder={t("enterDescription")}
            error={!!error}
          />
        )}
      />
      {error && <FormHelperText error>{error}</FormHelperText>}
    </FormControl>
  );
};
